// @generated by protoc-gen-connect-query v1.4.1 with parameter "target=ts"
// @generated from file no/jotta/openapi/photo/v2/album.v2.proto (package no.jotta.openapi.photo.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { MethodKind } from "@bufbuild/protobuf";
import { AddPhotosToAlbumRequest, AddPhotosToAlbumResponse, GetAlbumRequest, GetAlbumResponse, GetAlbumsRequest, GetAlbumsResponse, SetCoverPhotoRequest, SetCoverPhotoResponse, SharePhotosRequest, SharePhotosResponse, UnshareAlbumRequest, UnshareAlbumResponse } from "./album.v2_pb.js";
import { PingRequest, PingResponse } from "../../ping_pb.js";
/**
 * @generated from rpc no.jotta.openapi.photo.v2.AlbumService.GetAlbums
 */
export const getAlbums = {
    localName: "getAlbums",
    name: "GetAlbums",
    kind: MethodKind.Unary,
    I: GetAlbumsRequest,
    O: GetAlbumsResponse,
    service: {
        typeName: "no.jotta.openapi.photo.v2.AlbumService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.photo.v2.AlbumService.GetAlbum
 */
export const getAlbum = {
    localName: "getAlbum",
    name: "GetAlbum",
    kind: MethodKind.Unary,
    I: GetAlbumRequest,
    O: GetAlbumResponse,
    service: {
        typeName: "no.jotta.openapi.photo.v2.AlbumService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.photo.v2.AlbumService.SetCoverPhoto
 */
export const setCoverPhoto = {
    localName: "setCoverPhoto",
    name: "SetCoverPhoto",
    kind: MethodKind.Unary,
    I: SetCoverPhotoRequest,
    O: SetCoverPhotoResponse,
    service: {
        typeName: "no.jotta.openapi.photo.v2.AlbumService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.photo.v2.AlbumService.SharePhotos
 */
export const sharePhotos = {
    localName: "sharePhotos",
    name: "SharePhotos",
    kind: MethodKind.Unary,
    I: SharePhotosRequest,
    O: SharePhotosResponse,
    service: {
        typeName: "no.jotta.openapi.photo.v2.AlbumService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.photo.v2.AlbumService.UnshareAlbum
 */
export const unshareAlbum = {
    localName: "unshareAlbum",
    name: "UnshareAlbum",
    kind: MethodKind.Unary,
    I: UnshareAlbumRequest,
    O: UnshareAlbumResponse,
    service: {
        typeName: "no.jotta.openapi.photo.v2.AlbumService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.photo.v2.AlbumService.AddPhotosToAlbum
 */
export const addPhotosToAlbum = {
    localName: "addPhotosToAlbum",
    name: "AddPhotosToAlbum",
    kind: MethodKind.Unary,
    I: AddPhotosToAlbumRequest,
    O: AddPhotosToAlbumResponse,
    service: {
        typeName: "no.jotta.openapi.photo.v2.AlbumService"
    }
};
/**
 * Safe noop for testing purposes
 *
 * @generated from rpc no.jotta.openapi.photo.v2.AlbumService.Ping
 */
export const ping = {
    localName: "ping",
    name: "Ping",
    kind: MethodKind.Unary,
    I: PingRequest,
    O: PingResponse,
    service: {
        typeName: "no.jotta.openapi.photo.v2.AlbumService"
    }
};
